// Initialize a global array to store the product handles
var currentProductHandles = [];
if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        //cross-sell-popup product data updating based on product metafileds
        await crossSellPopup(this.submitButton);  
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
         
        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        const formData = new FormData(this.form);
        
        /**bulk buy**/
        const pricePerItemContainer = document.querySelector('.price-per-quantity__container');
        const isProductOrCollectionPage = window.location.pathname.includes('/products/') || window.location.pathname.includes('/collections/');
        const isMainBuyButton = this.submitButton.classList.contains('main_buy_button');
        const isOfferBuyButton = this.submitButton.classList.contains('offer_buy_button');

        if (isProductOrCollectionPage && isMainBuyButton) {
          if (pricePerItemContainer && pricePerItemContainer.getAttribute('data-quantityselector') === 'true') {
            const selectedOption = document.querySelector('.multiple-quantity_selector input[name="option"]:checked');
            formData.set('quantity', selectedOption ? selectedOption.value : 1);
          } else {
            const quantityInput = document.querySelector('.product__info-wrapper .quantity__input');
            formData.set('quantity', quantityInput ? quantityInput.value : 1);
          }
        }

        /** Offer Buy **/
        if (isOfferBuyButton) {
          const offerBuyButton = this.submitButton; 
          if (offerBuyButton) {
            const offerValueNumber = Number(offerBuyButton.value); 
            formData.set('quantity', offerValueNumber);
          }
        }



        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
        

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
           
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              
              this.handleErrorMessage(response.description);
              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}




async function crossSellPopup(submitButton) {
  // logic to handle product handles, fetch cart, filter handles, and create product cards
  const clickedProductTitle = submitButton.getAttribute('data-title');
  const metaFieldProductHandles = submitButton.getAttribute('data-handles');

  if (metaFieldProductHandles) {
    const productHandles = metaFieldProductHandles.split(',').map(item => item.trim()).filter(item => item !== "");
    let cartHandles = [];

    try {
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      const handles = cart.items.map(item => item.handle);
      cartHandles = handles.join(',');
    } catch (error) {
      console.error('Error fetching cart:', error);
    }

    const filteredProductHandles = productHandles.filter(handle => !cartHandles.includes(handle));
    currentProductHandles = filteredProductHandles;

    const createProductCard = (productUrl) => {
      const card = document.createElement('li');
      card.classList.add('owl-slide', 'slider-item');

      fetch(productUrl)
        .then(response => response.text())
        .then(data => {
          card.innerHTML = data;
          const upsellProductList = document.getElementById('upsell-product-list');
          upsellProductList.appendChild(card);
          const currentLength = currentProductHandles.length;
          card.classList.add(`card-length-${currentLength}`);
          initializeCrossSellCarousel();
        })
        .catch(error => {
          console.error('Error fetching product card:', error);
        });
    };

    const upsellProductList = document.getElementById('upsell-product-list');
    upsellProductList.innerHTML = '';

    currentProductHandles.forEach(handle => {
      const productUrl = `/products/${handle}?view=card`;
      createProductCard(productUrl);
    });

    if (currentProductHandles.length > 0) {
      const checkIfCardsAdded = setInterval(() => {
        const upsellProductList = document.getElementById('upsell-product-list');
        if (upsellProductList && upsellProductList.children.length > 0) {
          const mainPopupCard = document.querySelector('.main-popup-card');
          if (mainPopupCard) {
            mainPopupCard.classList.remove('hidden');
            document.querySelector('body').classList.add('cross-sell-open');
          }
          clearInterval(checkIfCardsAdded);
        }

        const productPopupTitle = document.querySelector('.product-popup-title');
        if (productPopupTitle) {
          productPopupTitle.innerText = clickedProductTitle;
        }
      }, 100);
    } else {
      const mainPopupCard = document.querySelector('.main-popup-card');
      if (mainPopupCard) {
        document.querySelector('body').classList.remove('cross-sell-open');
        mainPopupCard.classList.add('hidden');
      }
    }
  } else {
    const mainPopupCard = document.querySelector('.main-popup-card');
    if (mainPopupCard) {
      document.querySelector('body').classList.remove('cross-sell-open');
      mainPopupCard.classList.add('hidden');
    }
  }
}






// Cross cell popup close
var popupCloseButton = document.querySelector('#close-popup');
var crossSellModal = document.querySelector('.main-popup-card');
var overlay = document.querySelector('.cross-cell-main-overlay');

function closeModal() {
  crossSellModal?.classList.add('hidden');
  document.querySelector('body').classList.remove('cross-sell-open', 'overflow-hidden');
}
// Close popup on clicking the close button
popupCloseButton?.addEventListener('click', function() {
  closeModal()
});
// Close popup when clicking outside of the modal or overlay
document.addEventListener('click', (event) => {
  if (event.target.classList.contains('cross-cell-outer-container')) {
     closeModal()
  }
});

function initializeCrossSellCarousel() {
  // Destroy the existing carousel and reinitialize it
  if ($('.cross-cell-products-owl-carousel').data('owl.carousel')) {
      $('.cross-cell-products-owl-carousel').trigger('destroy.owl.carousel');
  }

  // Initialize the Owl Carousel
  $('.cross-cell-products-owl-carousel').owlCarousel({
      loop: false,
      nav: true,
      margin: 10,
      responsive: {
          0: {
            items: 1,
            dots: false,
            margin: 0
          },
          600: {
            items: 2,
            dots: false
          },
          768: {
            items: 3,
            dots: false
          },
          1024: {
            items: 4,
            dots: false
          },
      }
  });
}                                                  



   
